import React from "react";

import NeedHelp from '../need-help'

import { scrollError } from '../../helpers'

interface SubmitButtonsProps {
  [key: string]: any
}

const SubmitButtons: React.FC<SubmitButtonsProps> = (props:any) => {

  return (
    <>
      <div className="row">
        <div className="submit-buttons clearfix box">
          { props.values.payment_type === 'Single' &&
            <div className="medium-6 columns">
              <h2>I want to donate using</h2>
              <button
                className="btn-cta go"
                id="pay-by-card-button"
                tabIndex={0}
                type="submit"
                onClick={() => {
                  scrollError()
                  props.setFieldValue('payment_method', 'CreditCard')
                }}
                onKeyPress={() => {
                  scrollError()
                  props.setFieldValue('payment_method', 'CreditCard')
                }}>
                  Card
                </button>
              <div className="supported-cards show-for-small">
                <img src="/assets/default/images/supported-cards.png" alt="Supported cards: Visa, Mastercard, Maestro & American Express"/>
              </div>
              <button type="button" className="btn-cta go" id="paypal-button" tabIndex={-1}>
                <span>PayPal</span>
              </button>
              <button
                className="btn-cta go"
                id="paypal-trigger"
                tabIndex={0}
                type="submit"
                onClick={() => {
                  scrollError()
                  props.setFieldValue('payment_method', 'PayPal')
                }}
                onKeyPress={() => {
                  scrollError()
                  props.setFieldValue('payment_method', 'PayPal')
                }}>
                <span>PayPal</span>
              </button>
              <div className="braintree-logo show-for-small">
                <img src="/assets/default/images/braintree.png" alt="Payments by braintree"/>
              </div>
              <div className="large-12 columns divider show-for-small"></div>
            </div>
           }
           { props.values.payment_type === 'Regular' &&
            <>
              <div className="medium-6 columns">
                <button
                  className="btn-cta go"
                  id="set-up-regular-gift"
                  tabIndex={0}
                  type="submit"
                  onClick={() => {
                    scrollError()
                    props.setFieldValue('payment_method', 'DirectDebit')
                  }}
                  onKeyPress={() => {
                    scrollError()
                    props.setFieldValue('payment_method', 'DirectDebit')
                  }}>Next</button>
              </div>
            </>
          }
          <div className="medium-6 columns">
            <NeedHelp />
          </div>
          { props.values.payment_type === 'Single' &&
            <>
              <div className="large-12 columns divider hide-for-small"></div>
              <div className="medium-6 columns hide-for-small">
                <div className="supported-cards">
                  <img src="/assets/default/images/supported-cards.png" alt="Supported cards: Visa, Mastercard, Maestro & American Express"/>
                </div>
              </div>
              <div className="medium-6 columns bt-desktop hide-for-small">
                <div className="braintree-logo">
                  <img src="/assets/default/images/braintree.png" alt="Payments by braintree"/>
                </div>
              </div>
            </>
          }
        </div>
      </div>
    </>
  );
};

export default SubmitButtons;